import * as actions from "../actions";

const initialState = {
  applicationEverRefused: null,
  partnerApplicationRefused: null,
  heldSuspendedDocument: null,
  partnerHeldSuspendedDocument: null,
  disciplinaryAgainstYou: null,
  disqualifiedToHoldLicence: null,
  isCorporationMgmtSubjectToWindingUpOrder: null,
  undischargedBankrupt: null,
  partnerUndischargedBankrupt: null,
  isCorporationSubjectToWindingUpOrder: null,
  applicationEverRefusedComment: null,
  partnerApplicationRefusedComment: null,
  heldSuspendedDocumentComment: null,
  partnerHeldSuspendedDocumentComment: null,
  disciplinaryAgainstYouComment: null,
  disqualifiedToHoldLicenceComment: null,
  isCorporationMgmtSubjectToWindingUpOrderComment: null,
  undischargedBankruptComment: null,
  partnerUndischargedBankruptComment: null,
  isCorporationSubjectToWindingUpOrderComment: null,
  finished: null,
  step: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.STORE_DISCLOSURES:
      return {
        ...state,
        ...action.payload
      };
    case actions.GET_APPLICATION_FULFILLED:
      return {
        ...action.payload.disclosures
      };
    case actions.CLEAR_FORM:
      return {
        ...initialState,
      };
    default:
      return state
  }
}
